import { CompanyTitledPage } from "../../TitledPage";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import Button from "@mui/material/Button";

import { useNavigate } from "react-router-dom";
import { CompanyPartHeader } from "../../../components/PartHeader";
import useInputObject from "../../../hooks/useInputObject";
import { addProduct, getMaxProductId } from "../../../http/api/ProductAPI";
import ProductInfo from "../ProductInfo/ProductInfo";
import { useContext, useEffect, useState } from "react";
import { MSG_ERR_DUPLICATED_PRODUCT_ID, MSG_ERR_UNEXPECTED } from "../../../common/message";
import { ScreenStatusContext } from "../../../context/ScreenStatusContext";
import { confirmWhenChanged } from "../../../utils/validation";

const infoTableCellSx = {
  fontSize: 18,
};

// 新規商品登録ページ
export default function ProductRegisterPage() {
  const navigate = useNavigate();

  const product = useInputObject();

  // 登録中をあらわすstate
  const [isRegistering, setRegistering] = useState(false);
  // 画面ステータスをcontextから取得
  const {isChanged} = useContext(ScreenStatusContext);

  //商品ダイアログ初期処理
  useEffect(() => {
    initializeProductInfo();
  }, []);

  // 商品ダイアログの初期処理(登録商品ID設定)を実行する
  const initializeProductInfo = async () => {
    let response = await getMaxProductId();
    
    product.setValue({
      productId: (response.maxProductId + 1).toString()
    });
  }

  async function handleClickRegister() {
    setRegistering(true);

    product.Value.createdId = 1; //TODO JWT追加した後削除
    product.Value.updatedId = 1; //TODO JWT追加した後削除

    try {
      let productId = await addProduct(product.Value);
      alert("商品を追加しました。");
      navigate("/company/product", {
        state: { productId},
      });
    } catch (e) { 
      if (e.response.data === 'DuplicateKeyException') {
        alert(MSG_ERR_DUPLICATED_PRODUCT_ID);
      } else {
        alert(MSG_ERR_UNEXPECTED);
      }
    } finally {
      setRegistering(false);
    }
    
  }
  
  const handleClickReturn = (event) => {
    if (confirmWhenChanged(isChanged)) {
      navigate(-1);
    }
  };

  return (
    <CompanyTitledPage title="商品登録">
      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              商品情報の入力
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={handleClickRegister} disabled={isRegistering}>
              登録
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={handleClickReturn}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>

      {/* 商品情報 */}
      <ProductInfo product={product} />
    </CompanyTitledPage>
  );
}
